import { convertToRgba } from './convertToRgba';
export const convertColorsToRgba = (colors) => {
    const result = {};
    for (const colorName of Object.keys(colors)) {
        const color = colors[colorName];
        const value = typeof color === 'object'
            ? convertColorsToRgba(color)
            : convertToRgba(color);
        if (value) {
            result[colorName] = value;
        }
    }
    return result;
};
//# sourceMappingURL=convertColorsToRgba.js.map